import { AsYouType } from 'libphonenumber-js';

// Formato canônico salvo/enviado à API: apenas dígitos (ex.: "5582988767694").
const getWhatsappNumbers = (value = '') => value.replace(/\D/g, '');

// Formata os dígitos para exibição, igual ao edusynch-student:
// Brasil -> "+55 (82) 98876-7694"; demais países -> AsYouType do libphonenumber-js.
const formatWhatsappDisplay = (value = '') => {
  const numbers = getWhatsappNumbers(value);
  if (!numbers) return '';

  try {
    const formatter = new AsYouType();
    const formatted = formatter.input('+' + numbers);
    const detectedCountry = formatter.getCountry();

    if (detectedCountry === 'BR' && numbers.startsWith('55')) {
      const rest = numbers.substring(2);
      if (rest.length === 0) return '+55 ';
      if (rest.length <= 2) return `+55 (${rest}`;

      const areaCode = rest.substring(0, 2);
      const phoneNumber = rest.substring(2);
      if (phoneNumber.length === 0) return `+55 (${areaCode}) `;
      if (phoneNumber.length <= 5) return `+55 (${areaCode}) ${phoneNumber}`;

      const firstPart = phoneNumber.substring(0, 5);
      const secondPart = phoneNumber.substring(5, 9);
      return `+55 (${areaCode}) ${firstPart}${
        secondPart ? '-' + secondPart : ''
      }`;
    }

    return formatted || '+' + numbers;
  } catch {
    return '+' + numbers;
  }
};

export { getWhatsappNumbers, formatWhatsappDisplay };
